import { render, staticRenderFns } from "./RelatedAssets.vue?vue&type=template&id=3de5c0f8&scoped=true"
import script from "./RelatedAssets.vue?vue&type=script&lang=js"
export * from "./RelatedAssets.vue?vue&type=script&lang=js"
import style0 from "./RelatedAssets.vue?vue&type=style&index=0&id=3de5c0f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de5c0f8",
  null
  
)

export default component.exports